var Utils = {
    initArray(dest, src) {
        if (!dest || !src) return null;
        dest.length = 0;
        src.map(i => dest.push(i));
        return dest;
    },
    initFilters(filters, products) {
        if (!filters || !products) return null;
        let functions = this.getDistinctValues(products, "functions");
        let ecolabels = this.getDistinctValues(products, "ecolabels");
        this.initArray(filters.functions, functions);
        this.initArray(filters.ecolabels, ecolabels);
        let rciRange = this.getMinMaxRange(products, "rci");
        let ewgRange = this.getMinMaxRange(products, "ewgScoreMin", "ewgScoreMax");
        filters.rciRange[0] = rciRange[0];
        filters.rciRange[1] = rciRange[1];
        filters.ewgRange[0] = ewgRange[0];
        filters.ewgRange[1] = ewgRange[1];
        return filters;
    },
    getDistinctValues(objects, property) {
        let dict = {};
        if (objects && property) {
            objects.map(o => {
                if (o.hasOwnProperty(property)) {
                    o[property].map(tag => {
                        dict[tag.id] = tag.name;
                    })
                }
            });
        }
        let ret = [];
        for (var p in dict) {
            if (dict.hasOwnProperty(p)) {
                ret.push({id: p, name: dict[p]});
            }
        }
        ret.sort((a, b) => {
            if (a.name < b.name) return -1;
            else if (a.name > b.name) return 1;
            else return 0;
        });
        return ret;
    },
    getMinMaxRange(objects, minProperty, maxProperty) {
        if (!objects || !minProperty) return [0, 0];
        if (!maxProperty) maxProperty = minProperty;
        let min = 1000000;
        let max = -1000000;
        objects.map(o => {
            if (o.hasOwnProperty(minProperty) && o[minProperty] < min) min = o[minProperty];
            if (o.hasOwnProperty(maxProperty) && o[maxProperty] > max) max = o[maxProperty];
        });
        return [min, max];
    },
    applyFilters(dataset, filters) {
        let ret = [];
        if (dataset && dataset.length > 0 && filters) {
            dataset.map(p => {
                if (this.productMatches(p, filters)) ret.push(p);
            });
        }
        return ret;
    },
    productMatches(prod, filters) {
        if (!prod || !filters) return false;
        
        if (filters.function && !prod.functions.find(f => {return f.id === filters.function})) return false;
        if (filters.ecolabels && filters.ecolabels.length > 0) {
            let matches = true;
            filters.ecolabels.map(e => {
                if (!prod.ecolabels.find(o => {return o.id === e;})) matches = false;
            });
            if (!matches) return false;
        }
        if (prod.rci > filters.rci[1] || prod.rci < filters.rci[0]) return false;
        if (prod.ewgScoreMax > filters.ewg[1] || prod.ewgScoreMin < filters.ewg[0]) return false;
        return true;
    }
};

export default Utils;